// @ts-check
import * as React from "react";
import classNames from "classnames";
import ProductTeaserItem from "./product-teaser-item";
import TitleTop from "../Shared/TitleTop/title-top";

const ProductTeaser = props => {
    const baseClass = "product-teaser";
    const rootClasses = classNames(baseClass, "content-module");

    return (
        <div className={rootClasses}>
            {props.Title && <TitleTop {...props} />}
            <div className={`${baseClass}-inner content-module__landingpage-inner`}>
                {props.Works.length > 0 &&
                    props.Works.map((item, index) => {
                        const product = item.Products[0];

                        return <ProductTeaserItem key={index} product={product} />;
                    })}
            </div>
        </div>
    );
};

export default ProductTeaser;
